import { __makeTemplateObject } from '../../../../node_modules/tslib/tslib.es6.js';
import styled from 'styled-components';
import { color } from '../../../styles/styles.js';
var PopOutMenuStyled = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  background-color: ", ";\n  border: solid 1px ", ";\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.25);\n  margin: 0;\n  padding: 0;\n  width: ", ";\n  list-style: none;\n  z-index: 99;\n  border-radius: ", ";\n  overflow: hidden;\n"], ["\n  position: absolute;\n  background-color: ", ";\n  border: solid 1px ", ";\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.25);\n  margin: 0;\n  padding: 0;\n  width: ", ";\n  list-style: none;\n  z-index: 99;\n  border-radius: ", ";\n  overflow: hidden;\n"])), function (props) {
  return props.theme === 'dark' ? color.darkModeDark : '#fff';
}, function (props) {
  return props.theme === 'dark' ? color.darkModeMedium : color.border;
}, function (_a) {
  var fitWidthToContent = _a.fitWidthToContent;
  return fitWidthToContent ? 'fit-content' : '100%';
}, function (_a) {
  var menuBorderRadius = _a.menuBorderRadius;
  return menuBorderRadius;
});
var templateObject_1;
export { PopOutMenuStyled };